<template>
  <div class="workbench">
    <div class="workbench-head">
      <div class="workbench-head-left">
        <!-- <div class="head-portrait">
          <div class="head-portrait-container">
            <img
              src=""
              alt="error"
            >
          </div>
        </div> -->
        <div class="user-info">
          <div class="hello">
            您好，{{ userData.name }}，欢迎来到营销中心！
          </div>
          <div class="user-name-com">
            {{ userData.accountName }}
          </div>
        </div>
      </div>
      <div class="workbench-head-right">
        <!-- <div class="head-lead">
          <div class="head-lead-item">
            <div class="number">
              2048
            </div>
            <div class="lead-type">
              微信线索
            </div>
          </div>
          <div class="line"></div>
          <div class="head-lead-item">
            <div class="number">
              521
            </div>
            <div class="lead-type">
              微信好友
            </div>
          </div>
        </div> -->
        <div
          v-if="userData.headImg"
          class="saler-extra-info"
        >
          <div class="saler-extra-portrait">
            <img
              :src="userData.headImg"
              alt="error"
              class="img"
            />
          </div>
          <div class="saler-extra-name">
            <div class="title">
              当前登录微信
            </div>
            <div class="name">
              {{ userData.nickName }}
            </div>
          </div>
        </div>
        <div class="view-select">
          <mk-dropdown @command="handleClick">
            <mk-button-biz
              type="primary"
              height="35"
            >
              <div class="button-txt">
                <div
                  class="icon-container"
                  :class="{'icon-yingxiao': activeView === 'two'}"
                >
                  <div
                    class="img-icon"
                    :class="{ 'margin-icon': activeView === 'one' }"
                  >
                    <mk-iconfont
                      v-if="activeView === 'one'"
                      icon-class="xiaoshoushitu"
                    ></mk-iconfont>
                    <mk-iconfont
                      v-if="activeView === 'two'"
                      icon-class="yingxiaoshitu"
                    ></mk-iconfont>
                    <mk-iconfont
                      v-if="activeView === 'three'"
                      icon-class="guanlishitu"
                    ></mk-iconfont>
                  </div>
                </div>
                <span>{{ activeDropdown }}</span>
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </div>
            </mk-button-biz>
            <mk-dropdown-menu slot="dropdown">
              <mk-dropdown-item
                v-if="workBenchMenu.indexOf('func_sales_view') !== -1"
                command="one"
              >
                销售视图
              </mk-dropdown-item>
              <mk-dropdown-item
                v-if="workBenchMenu.indexOf('func_marketing_view') !== -1"
                command="two"
              >
                营销视图
              </mk-dropdown-item>
              <mk-dropdown-item
                v-if="workBenchMenu.indexOf('func_manage_view') !== -1"
                command="three"
              >
                管理视图
              </mk-dropdown-item>
            </mk-dropdown-menu>
          </mk-dropdown>
        </div>
      </div>
    </div>
    <div class="switch-view">
      <sales-view v-if="activeView === 'one'"></sales-view>
      <marketing-view v-else-if="activeView === 'two'"></marketing-view>
      <manage-view v-else></manage-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SalesView from './components/sales-view'
import MarketingView from './components/marketing-view'
import ManageView from './components/manage-view'
export default {
  name: 'Workbench',
  components: {
    SalesView,
    MarketingView,
    ManageView
  },
  data () {
    return {
      activeView: 'one',
      activeDropdown: '销售视图',
      // 用户信息
      userData: {}
    }
  },
  computed: {
    ...mapGetters('system', ['workBenchMenu'])
  },
  watch: {
    workBenchMenu (menu) {
      this.filterMenu(menu)
    }
  },
  mounted () {
    this.getCompanyName()
    // 切换菜单时，store里面的值已经有了，watch不会触发
    if (this.workBenchMenu.length > 0) {
      this.filterMenu(this.workBenchMenu)
    }
  },
  methods: {
    handleClick (val) {
      this.activeView = val
      this.filterDropdown(val)
    },
    // 判断当前页面应该首先显示哪一个视图,根据拿到的菜单
    filterMenu (menu) {
      let active
      if (menu.indexOf('func_sales_view') !== -1) {
        active = 'one'
      } else if (menu.indexOf('func_marketing_view') !== -1) {
        active = 'two'
      } else if (menu.indexOf('func_manage_view') !== -1) {
        active = 'three'
      }
      this.activeView = active
      this.filterDropdown(active)
    },
    // 获取公司名称
    getCompanyName () {
      let userData = JSON.parse(window.localStorage.getItem('user'))
      this.userData = userData
    },
    filterDropdown (val) {
      switch (val) {
        case 'one':
          this.activeDropdown = '销售视图'
          break
        case 'two':
          this.activeDropdown = '营销视图'
          break
        case 'three':
          this.activeDropdown = '管理视图'
          break

        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.workbench {
  background-color: #f0f1f2;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  .workbench-head {
    background-color: #fff;
    padding: 0 17px 0 29px;
    height: 136px;
    display: flex;
    align-items: center;
    border: 1px solid rgba(232, 232, 232, 1);
    border-top: none;

    .workbench-head-left {
      flex: 2;
      display: flex;

      .head-portrait {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background-color: blue;
        flex-shrink: 0;
      }

      .user-info {
        margin-left: 20px;
        height: 72px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .hello {
          color: #262626;
          font-size: 16px;
          font-weight: 500;
        }

        .user-name-com {
          color: #8c8c8c;
          font-size: 13px;
        }
      }
    }

    .workbench-head-right {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .head-lead {
        height: 72px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .head-lead-item {
          height: 72px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          min-width: 60px;
          box-sizing: border-box;

          .number {
            font-size: 20px;
            color: #262626;
          }

          .lead-type {
            color: #8c8c8c;
            font-size: 13px;
          }
        }

        .line {
          margin: 0 20px;
          display: block;
          width: 1px;
          height: 40px;
          background: #e9e9e9;
        }
      }

      .saler-extra-info {
        display: flex;
        padding-right: 34px;

        &::after {
          content: '';
          position: relative;
          right: -34px;
          top: 5px;
          display: inline-block;
          height: 30px;
          width: 1px;
          background-color: #e9e9e9;
        }

        .saler-extra-portrait {
          width: 40px;
          height: 40px;
          flex-shrink: 0;

          .img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
          }
        }

        .saler-extra-name {
          margin-left: 10px;
          font-size: 14px;
          line-height: 20px;

          .title {
            color: #8c8c8c;
          }

          .name {
            color: #000;
          }
        }
      }

      .view-select {
        display: flex;
        align-items: center;
        margin-left: 34px;

        .button-txt {
          height: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        /deep/ .el-button {
          height: 35px !important;
          padding: 0 12px 0 14px !important;
        }

        .icon-container {
          // margin-right: 6px;
          margin: 0 6px 0 4px;
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background-color: #39f;

          &.icon-yingxiao {
            background-color: #ff9500;
          }

          .icon-mk-xiaoshoushitu,
          .icon-mk-yingxiaoshitu,
          .icon-mk-guanlishitu {
            color: #fff;
            font-size: 12px;
          }

          .img-icon {
            width: 12px;
            height: 12px;
            margin: 2px;

            .img {
              width: 100%;
              height: 100%;
            }
          }

          .margin-icon {
            margin: 1px 1px 0 2px;
          }
        }

        .el-button {
          padding: 10px 20px 11px;
          background-color: #f5f5f5;
          color: #595959;
          border: none;
          font-size: 13px;
        }

        .icon-arrow-down {
          color: #595959;
        }
      }
    }
  }

  .switch-view {
    flex: 1;
    margin-top: 10px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  /deep/ .el-card {
    border-radius: 0;
    box-shadow: none;
    border: 1px solid rgba(232, 232, 232, 1);
  }

  /deep/ .el-radio-button__inner {
    padding: 8px 20px;
  }

  /deep/ .el-card__header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    font-weight: 500;
  }
}
</style>
